import { render, staticRenderFns } from "./FooterLegal.vue?vue&type=template&id=3abeaa36&scoped=true"
import script from "./FooterLegal.vue?vue&type=script&lang=js"
export * from "./FooterLegal.vue?vue&type=script&lang=js"
import style0 from "./FooterLegal.vue?vue&type=style&index=0&id=3abeaa36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abeaa36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3abeaa36')) {
      api.createRecord('3abeaa36', component.options)
    } else {
      api.reload('3abeaa36', component.options)
    }
    module.hot.accept("./FooterLegal.vue?vue&type=template&id=3abeaa36&scoped=true", function () {
      api.rerender('3abeaa36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Footer/FooterLegal.vue"
export default component.exports